import { PlatformPage } from './PlatformPage'
import { ManagedPayoutsTab } from './tabs/ManagedPayoutsTab'

export function ManagedPayoutsPage() {
  return (
    <PlatformPage
      title="Managed Payouts"
      description="Tenants on Bokapsys-managed mode have their invoice payments collected by Bokapsys. Process payouts, track per-tenant balances, and review the platform's 1% fee revenue."
    >
      <ManagedPayoutsTab />
    </PlatformPage>
  )
}
